<template>
    <div class="form-group pb-0">
        <label v-if="showLabel" for="type" class="version-label col-form-label text-right">{{ label }}</label>
        <div class="version-selection-dd">
            <select2
                class="form-control"
                :value="channelInfo.selected"
                @input="handleSelect2Update"
                :config="{ placeholder: '', width: '100%' }">

                <option v-for="item in channelInfo.availableSelections" :value="item.id" :key="item.id">{{item.channel_name}}</option>

            </select2>
        </div>
    </div>
</template>

<script>

import axios from 'axios';

var base_url = window.location.protocol + "//" + window.location.host;

export default {
    name: 'channel-selector',
    props: {
        currentSelection: String,
        productId: {
            type: Number,
            default: -1
        },
        showLabel: {
            type: Boolean,
            default: true
        },
        label: {
            type: String,
            default: 'Version'
        }
    },
    data() {
        return {
            channelInfo: {
                selected: '0',
                availableSelections: [
                 {
                    id: 0,
                    channel_name: "Default",
                    slug: ""
                 }
                ],
            },
        }
    },
    mounted() {
        if (this.productId != -1) {
            axios.get(base_url + '/pimapi/products/' + this.productId + '/channels', {})
            .then((response) => {
                response.data.data.forEach((element, idx) => {
                    this.$set(this.channelInfo.availableSelections, idx+1, element);
                });
                this.$emit('channelSelectionChange', this.channelInfo.selected);
                this.$emit('availableSelections', this.channelInfo.availableSelections);
            })
            .catch((error) => {
                console.log('channel load ERROR!');
                console.log(error);
            });
        }
    },
    methods: {
        handleSelect2Update(update) {
            this.$emit('channelSelectionChange', update);
        },
    },
    computed: {},
};
</script>

<style>
.version-selection-dd {
    min-width: 300px;
}
.version-label{
    padding-bottom: 0;
}
</style>